import {FormatMessageFunction, ObjectOfAny} from '@fo/shared-types';
import {FieldErrorMessage} from '@fo/designSystem/Fields/types';
import {getObjectKeys} from '@fo/shared-helpers/objects';
import {
  isValidPassword,
  PasswordErrors,
  PasswordErrorKeys,
  MIN_LENGTH,
  MAX_LENGTH,
} from '../Password/passwordValidation';

const getPasswordMessage = (
  formatMessage: FormatMessageFunction,
  value: string,
  message?: FieldErrorMessage,
  messageValues: ObjectOfAny = {}
): string | undefined => {
  const validatedPasswordKeys: PasswordErrors = isValidPassword(value);
  const hasErrors: boolean = getObjectKeys(validatedPasswordKeys).some(
    (key: keyof PasswordErrors) => !validatedPasswordKeys[key]
  );

  if (hasErrors) {
    const errorMessages: string = getObjectKeys(validatedPasswordKeys)
      .reduce((acc: string[], key: keyof PasswordErrors) => {
        if (!validatedPasswordKeys[key]) {
          switch (key) {
            case PasswordErrorKeys.minimumLength as PasswordErrorKeys:
              acc.push(
                formatMessage({id: 'phoenix.errors.password.validation.minimumLength'}, {minimumLength: MIN_LENGTH})
              );
              break;
            case PasswordErrorKeys.maximumLength as PasswordErrorKeys:
              acc.push(
                formatMessage({id: 'phoenix.errors.password.validation.maximumLength'}, {maximumLength: MAX_LENGTH})
              );
              break;
            case PasswordErrorKeys.number as PasswordErrorKeys:
              acc.push(formatMessage({id: 'phoenix.errors.password.validation.number'}));
              break;
            case PasswordErrorKeys.specialCharacter as PasswordErrorKeys:
              acc.push(formatMessage({id: 'phoenix.errors.password.validation.specialCharacter'}));
              break;
            case PasswordErrorKeys.containsSpaces as PasswordErrorKeys:
              acc.push(formatMessage({id: 'phoenix.errors.password.validation.containsSpaces'}));
              break;
            case PasswordErrorKeys.lowerCase as PasswordErrorKeys:
              acc.push(formatMessage({id: 'phoenix.errors.password.validation.lowerCase'}));
              break;
            case PasswordErrorKeys.upperCase as PasswordErrorKeys:
              acc.push(formatMessage({id: 'phoenix.errors.password.validation.upperCase'}));
              break;
            default:
          }
        }
        return acc;
      }, [])
      .join(', ')
      .replace(
        /(,\s)(?!.*,\s)/g, // last comma + space
        ` ${formatMessage({id: 'phoenix.errors.password.validation.and'})} `
      );
    const errorMessage = `${formatMessage({id: 'phoenix.errors.password.validation.message'})} ${errorMessages}`;
    return typeof message === 'function' ? message(messageValues) : message || errorMessage;
  }
  return undefined;
};

export default getPasswordMessage;
